// extracted by mini-css-extract-plugin
export default {"container":"BellNotification_container__gH4x1","bell":"BellNotification_bell__sL33k","label":"BellNotification_label__d+49s","bg":"BellNotification_bg__2Hzpq"};